export var ECardType = /*#__PURE__*/ function(ECardType) {
    ECardType["INSURANCE"] = "INSURANCE";
    ECardType["SPECIAL_SALARY"] = "SPECIAL_SALARY";
    ECardType["SERVICE"] = "SERVICE";
    ECardType["CORPORATE_CARD"] = "CORPORATE_CARD";
    ECardType["CUSTOMS_CARD"] = "CUSTOMS_CARD";
    ECardType["ENTREPRENEUR_CARD"] = "ENTREPRENEUR_CARD";
    ECardType["STUDENT_CARD"] = "STUDENT_CARD";
    return ECardType;
}({});
export var EOrderType = /*#__PURE__*/ function(EOrderType) {
    EOrderType["NEW_CARD"] = "NEW_CARD";
    EOrderType["PROLONGATE_CARD"] = "PROLONGATE_CARD";
    EOrderType["RENEW_CARD"] = "RENEW_CARD";
    return EOrderType;
}({});
